import ClientStatementExpenseModel from 'uplisting-frontend/models/client-statement-expense';
import ClientStatementReportModel from 'uplisting-frontend/models/client-statement-report';
import ClientModel from 'uplisting-frontend/models/client';
import PropertyModel from 'uplisting-frontend/models/property';

export enum ClientStatementStatus {
  draft = 'draft',
  finalised = 'finalised',
  processing = 'processing',
}

export enum ClientStatementPaymentStatus {
  paid = 'paid',
  unknown = 'unknown',
  unpaid = 'unpaid',
}

export enum ClientStatementType {
  invoice = 'invoice',
  payout = 'payout',
}

export interface IOwnerPayoutConfiguration {
  accommodation: boolean;
  cleaning_fee: boolean;
  extra_charges: boolean;
  extra_guest_charge: boolean;
  booking_taxes: boolean;
  upsells: boolean;
  discount: boolean;
  channel_commission_with_tax: boolean;
  management_fee: boolean;
  payment_processing_fee: boolean;
  expenses: boolean;
}

export interface IClientStatementSchema {
  status: ClientStatementStatus;
  paymentStatus: ClientStatementPaymentStatus;
  htmlVersion: string;
  fileLink: string;
  startDate: string;
  endDate: string;
  currency: string;
  invoiceDate: Date;
  invoiceNumber: string;
  type: ClientStatementType;
  ownerPayoutConfiguration: IOwnerPayoutConfiguration;
  expenses: ClientStatementExpenseModel[];
  client: ClientModel;
  property: PropertyModel;
  report: ClientStatementReportModel;
}
